import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import formMixin from '../formMixin';
import get from 'lodash/get';
import set from 'lodash/set';
import pickBy from 'lodash/pickBy';
import keys from 'lodash/keys';
export default {
  name: 'NiotaClassicDevicetypesDownlinks',
  mixins: [formMixin],
  props: {
    deviceTypeId: {
      type: String,
      required: true
    },
    deviceTypeData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      downlinks: [],
      encodingTypes: ['base16', 'base64', 'utf8'],
      formSaving: false,
      formFields: [{
        title: 'name',
        required: true
      }, {
        title: 'payload',
        required: true
      }, {
        title: 'encoding',
        required: false
      }],
      validDownlinks: false,
      invalidIndices: []
    };
  },
  computed: {
    formCardButtons: function formCardButtons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        tooltip: this.$i18n_t('Common.save'),
        action: 'submit-form',
        valid: this.isIotHubManager ? this.validDownlinks : false
      }];
    }
  },
  watch: {
    deviceTypeData: function deviceTypeData() {
      this.handleDownlinksConfig();
    }
  },
  created: function created() {
    this.handleDownlinksConfig();
  },
  methods: {
    requiredRuleCheck: function requiredRuleCheck(cElement) {
      var _this = this;

      return function (v) {
        var bothEmpty = !cElement.name && !cElement.payload && !cElement.encoding;

        if (bothEmpty) {
          return true;
        }

        return _this.requiredRule[0](v);
      };
    },
    handleDownlinksConfig: function handleDownlinksConfig() {
      this.downlinks = get(this.deviceTypeData, 'properties.downlinks');

      if (!this.downlinks) {
        set(this.deviceTypeData, 'properties.downlinks', []);
        this.downlinks = get(this.deviceTypeData, 'properties.downlinks');
      }

      if (this.downlinks.length === 0) {
        // init downlinks
        this.addNewDownlink(0);
      }

      this.validate();
    },
    addNewDownlink: function addNewDownlink(index) {
      this.downlinks.splice(index + 1, 0, {
        name: null,
        payload: null,
        encoding: 'base16',
        port: 1,
        gatewayId: ''
      });
      this.validate();
    },
    removeDownlink: function removeDownlink(index) {
      this.downlinks.splice(index, 1);
      this.validate();
    },
    saveDownlinks: function saveDownlinks() {
      var _this2 = this;

      set(this.deviceTypeData, 'properties.downlinks', this.downlinks);
      this.formSaving = true;
      NiotaClassicApiService.deviceTypesUpdate(this.deviceTypeId, this.deviceTypeData, 'downlinks').then(function () {
        _this2.$snack(_this2.$i18n_t('NiotaClassic.DeviceTypes.snacks.downlinksSaved'), 'success');
      }).finally(function () {
        _this2.formSaving = false;
      }).catch(function () {
        _this2.$snack(_this2.$i18n_t('NiotaClassic.DeviceTypes.snacks.downlinksSaveFailed'), 'error');
      });
    },
    validate: function validate() {
      this.invalidIndices = keys(pickBy(this.downlinks, function (item) {
        return !item.name || !item.payload;
      }));
      this.validDownlinks = this.invalidIndices.length === 0;
    }
  }
};